import { queryOptions } from "@tanstack/react-query";
import { AztecWalletNotConnectedError, getAztecWalletAddress } from "../aztec-utils";

export const l2AccountAddressQuery = queryOptions({
  queryKey: ["l2_account", "address"],
  queryFn: async () => {
    // Try to get the address without triggering a connection
    const address = await getAztecWalletAddress();
    if (address) {
      return address;
    }
    // If no address, the wallet is not connected - throw the error
    throw new AztecWalletNotConnectedError();
  },
  retry: (failureCount, error) => {
    // Don't retry if the wallet is not connected
    if (error instanceof AztecWalletNotConnectedError) {
      return false;
    }
    return failureCount < 3;
  },
});
